module.exports = __webpack_public_path__ + "img/a-bank-logo.0f66262c.png";